import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { baseApi } from '@/api/baseApi';
import appearanceReducer from '@/features/appearance/appearanceSlice';
import authReducer from '@/features/auth/authSlice';
import tenantReducer from '@/features/tenant/tenantSlice';

export const store = configureStore({
  reducer: {
    appearance: appearanceReducer,
    auth: authReducer,
    tenant: tenantReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
  devTools: import.meta.env.DEV,
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
